import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiClient } from '@/shared/api';
import { type TypeTurnDetectionConfig } from '@intone/shared/types';

export function useTurnDetectionConfigs(configId: number) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['turn-detection-configs', configId],
    queryFn: async () => {
      return apiClient<TypeTurnDetectionConfig[]>(`/turn-detection-configs/${configId}`);
    },
  });
}

export function useSaveTurnDetectionConfig() {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (config: {
      id?: number;
      name: string;
      model_type?: string;
      unlikely_threshold?: number | null;
      min_endpointing_delay?: number;
      max_endpointing_delay?: number;
      min_response_delay?: number;
      max_response_delay?: number;
      interruption_threshold?: number;
      turn_taking_aggressiveness?: number;
      allow_first_phrase_interruptions?: boolean;
      min_endpointing_delay_on_interruption?: number | null;
      min_time_for_interruption_endpointing_delay?: number | null;
      agentId: string;
    }) => {

      return apiClient<TypeTurnDetectionConfig>('/turn-detection-configs/save', {
        method: 'POST',
        body: JSON.stringify(config),
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['turn-detection-configs'] });
      toast.success('Config saved successfully');
    },
    onError: (error) => {
      toast.error(error instanceof Error ? error.message : 'Failed to save config');
    },
  });
}